import React from "react";
import { Info, Save } from "lucide-react";

export default function ModalFooter({ onCancel, onSave }) {
  return (
    <div className="flex flex-col gap-4 border-t border-slate-100 px-6 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-8 bg-slate-50/40">
      <div className="flex items-center gap-2.5 rounded-lg border border-slate-200/60 bg-white px-3.5 py-2 sm:flex-1 max-w-md shadow-sm">
        <Info className="h-4 w-4 flex-none text-primary" aria-hidden="true" />
        <p className="font-sans text-xs text-slate-600 font-medium">
          Owners will be notified about leads assigned to the stages they own.
        </p>
      </div>

      <div className="flex flex-none items-center justify-end gap-3">
        <button
          type="button"
          onClick={onCancel}
          className="rounded-lg border border-slate-200 bg-white px-4 py-2 font-sans text-sm font-medium text-slate-700 transition-all duration-200 hover:bg-slate-50 hover:text-slate-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 focus-visible:ring-offset-2 shadow-sm"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={onSave}
          className="inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 font-sans text-sm font-medium text-white transition-all duration-200 hover:bg-primary-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 shadow-sm shadow-primary/10"
        >
          <Save className="h-4 w-4" aria-hidden="true" />
          Save Changes
        </button>
      </div>
    </div>
  );
}